import {
  Form,
  Select,
  Button,
  DatePicker,
  Row,
  Col,
  Segmented,
} from "antd";
import find from "lodash/find";
import map from "lodash/map";
import get from "lodash/get";
import dayjs from "dayjs";
import { getButtonDisabled } from "../../../utilities/helpers";
import {
  customWeekStartEndFormat,
  getCurrentDateRange,
} from "../../../utilities/report";
import { FileExcelOutlined } from "@ant-design/icons";

const HeaderSelector = ({
  filter,
  config,
  form,
  setFilters,
  setConfig,
  getDetails,
  isSameDay,
}) => {
  const disabledDate = (current) => {
    return current > dayjs().endOf("day");
  };
  return (
    <div className="w-full px-8 py-6">
      <Row className="" gutter={18}>
        <Col xs={24} md={6}>
          <Form.Item
            name="Company"
            label="Company"
            colon={false}
            layout="vertical"
          >
            <Select
              style={{ minWidth: 250 }}
              size="middle"
              value={get(filter, "company")}
              placeholder="Select Company"
              optionFilterProp="label"
              showSearch
              options={map(get(config, "companies"), (company) => ({
                label: get(company, "name"),
                value: get(company, "id"),
              }))}
              onChange={(val) => {
                const company = find(get(config, "companies"), ["id", val]);
                setFilters({
                  ...filter,
                  templateType: undefined,
                  company,
                });
                setConfig({
                  ...config,
                  template_types: get(company, "template_access_list"),
                });
                form.setFieldsValue({
                  template_type: undefined,
                });
              }}
            />
          </Form.Item>
        </Col>
        <Col xs={24} md={6}>
          <Form.Item
            name="template_type"
            label="Template Type"
            colon={false}
            layout="vertical"
          >
            <Select
              style={{ minWidth: 250 }}
              size="middle"
              placeholder="Type"
              options={map(get(config, "template_types"), (templateType) => ({
                label: get(templateType, "name"),
                value: get(templateType, "value"),
              }))}
              value={get(filter, "templateType")}
              onChange={(value) => {
                setFilters({
                  ...filter,
                  templateType: value,
                });
              }}
            />
          </Form.Item>
        </Col>
        {!isSameDay && (
          <Col xs={24} md={4}>
            <Form.Item
              initialValue={get(filter, "date2")}
              name="date"
              label="Date"
              colon={false}
              layout="vertical"
            >
              <DatePicker
                format={"DD/MM/YYYY"}
                disabledDate={disabledDate}
                onChange={(value, dateString) => {
                  setFilters({
                    ...filter,
                    date2: value,
                  });
                }}
                value={get(filter, "date2")}
              />
            </Form.Item>
          </Col>
        )}

        {isSameDay && (
          <Col xs={24} md={8}>
            <div className="flex gap-4">
              <Form.Item name="range" label=" " colon={false} layout="vertical">
                <Segmented
                  className="bg-gray-200"
                  options={[
                    { label: "Weekly", value: "week" },
                    { label: "Monthly", value: "month" },
                  ]}
                  value={get(filter, "interval")}
                  defaultValue={"week"}
                  onChange={(interval) => {
                    setFilters({
                      ...filter,
                      interval,
                      date: getCurrentDateRange(interval, dayjs()),
                    });
                  }}
                />
              </Form.Item>
              <div className="mt-8 ">
                {get(filter, "interval") === "week" ? (
                  <DatePicker
                    onChange={(value, dateString) => {
                      setFilters({
                        ...filter,
                        date: getCurrentDateRange(
                          get(filter, "interval"),
                          value
                        ),
                      });
                    }}
                    style={{ minWidth: 250 }}
                    format={customWeekStartEndFormat}
                    showWeek={false}
                    value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
                    picker="week"
                  />
                ) : (
                  <DatePicker
                    style={{ minWidth: 250 }}
                    format={"MM-YYYY"}
                    onChange={(value, dateString) => {
                      setFilters({
                        ...filter,
                        date: getCurrentDateRange(
                          get(filter, "interval"),
                          value
                        ),
                      });
                    }}
                    value={dayjs(get(filter, "date.0"), "YYYY-MM-DD")}
                    picker="month"
                  />
                )}
              </div>
            </div>
          </Col>
        )}

        <Col xs={24} md={2}>
          <Form.Item name="submit" label=" " colon={false} layout="vertical">
            <Button
              type="primary"
              className="w-30"
              onClick={getDetails}
              disabled={getButtonDisabled(filter, [
                "templateType",
                "company",
              ])}
              icon={<FileExcelOutlined />}
            >
              Download Excel
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </div>
  );
};

export default HeaderSelector;
